// FAQ 事件追踪脚本
(function () {
    // 工具函数
    function getDeviceType() {
        var wd_ret_userAgent = navigator.userAgent;
        if (/iPhone|iPad|iPod/i.test(wd_ret_userAgent)) {
          return "iOS";
        } else if (/Android/i.test(wd_ret_userAgent)) {
          return "Android";
        } else if (/Windows Phone/i.test(wd_ret_userAgent)) {
          return "Windows Phone";
        } else if (/Windows NT/i.test(wd_ret_userAgent)) {
          return "Windows";
        } else if (/Macintosh/i.test(wd_ret_userAgent)) {
          return "Mac";
        } else if (/Linux/i.test(wd_ret_userAgent)) {
          return "Linux";
        } else {
          return "Unknown";
        }
    }

    function isSatellaiApp() {
        return navigator.userAgent.toLocaleLowerCase().includes('satellai-app');
    }

    // 防抖函数
    function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    function extractAppInfo(ua) {
        const result = {};
        const platformMatch = ua.match(/PLATFORM:\s*([A-Z0-9._-]+)/i);
        const versionMatch = ua.match(/VERSION:\s*([A-Z0-9._-]+)/i);
        const applicationMatch = ua.match(/APPLICATION:\s*([A-Z0-9 ._-]+)/i);
      
        if (platformMatch) result.platform = platformMatch[1];
        if (versionMatch) result.version = versionMatch[1];
        if (applicationMatch) result.application = applicationMatch[1].trim();
      
        return result;
      }

    // 构建基础事件数据
    function buildEventData(eventName, customData = {}) {
        var baseData = {
            device_type: getDeviceType(),
            event: eventName
        };

        // 检查是否在 Satellai App 中
        if (isSatellaiApp()) {

            try {
                var satellai_app_info = extractAppInfo(navigator.userAgent);
                baseData.platform = satellai_app_info.platform;
                baseData.version = satellai_app_info.version;
                baseData.application = satellai_app_info.application;
            } catch (error) { }
        } else {
            baseData.user_agent = navigator.userAgent;
        }

        // 合并自定义数据
        return Object.assign(baseData, customData);
    }

    // 发送事件到分析平台
    function sendEvent(eventData) {
        // 推送到 dataLayer
        if (window.dataLayer) {
            window.dataLayer.push(eventData);
        }


        console.log('FAQ Event Sent:', eventData);
    }

    // FAQ 点击事件追踪
    function trackFAQClick(faqQuestion, faqAction) {
        var eventData = buildEventData('faq_click', {
            faq_question: faqQuestion,
            faq_action: faqAction
        });
        sendEvent(eventData);
    }

    // FAQ 搜索事件追踪
    function trackFAQSearch(searchTerm) {
        if (!searchTerm || searchTerm.trim().length < 2) return; // 最少2个字符

        var eventData = buildEventData('faq_search', {
            search_term: searchTerm.trim(),
            search_type: 'faq_search'
        });
        sendEvent(eventData);
    }

    // 防抖后的搜索追踪函数（1.5秒后触发）
    var debouncedTrackSearch = debounce(trackFAQSearch, 1500);

    // 初始化事件监听
    function initFAQTracking() {
        // FAQ 点击事件监听
        var faqUl = document.getElementById('simesyfaqgroup');
        if (faqUl) {
            faqUl.addEventListener('click', function (event) {
                // 只处理点击问题标题部分
                var questionDiv = event.target.closest('.simesyfaq__question');
                if (!questionDiv) return;

                var faqItem = questionDiv.closest('.simesyfaq');
                if (!faqItem) return;

                var textSpan = questionDiv.querySelector('.simesyfaq__text');
                var faq_question = textSpan ? textSpan.textContent.trim() : '';

                // 获取当前状态
                var currentState = faqItem.getAttribute('data-simesyfaq-state');
                var faq_action = currentState === 'expanded' ? 'close' : 'open';

                trackFAQClick(faq_question, faq_action);
            });
        }

        // FAQ 搜索事件监听
        var searchInput = document.querySelector('.faq-page__search-box input[type="text"]');
        if (searchInput) {
            // 监听输入事件（防抖）
            searchInput.addEventListener('input', function (event) {
                var searchTerm = event.target.value;
                debouncedTrackSearch(searchTerm);
            });

            // 监听回车键（立即上报）
            searchInput.addEventListener('keypress', function (event) {
                if (event.key === 'Enter') {
                    var searchTerm = event.target.value;
                    trackFAQSearch(searchTerm);
                }
            });

            // 监听失焦事件
            searchInput.addEventListener('blur', function (event) {
                var searchTerm = event.target.value;
                if (searchTerm.trim().length >= 2) {
                    trackFAQSearch(searchTerm);
                }
            });
        }
    }

    // 页面加载完成后初始化
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initFAQTracking);
    } else {
        initFAQTracking();
    }


})();
